import { CircleCheck } from "lucide-react";

import { useCheckUser } from "@/api/user/check-user";
import { Card } from "@/components/ui/card";
import StoreInfoForm from "@/components/onboarding/store-info-form";
import useOnboardingData from "@/store/onboarding-data";
import { useNavigate } from "react-router";
import useGlobalLoading from "@/store/global-loading";
import { useEffect } from "react";

const StepOne = () => {
    const { isLoading } = useCheckUser();
    const { isStep1Complete } = useOnboardingData();
    const { setIsLoading } = useGlobalLoading();

    const navigate = useNavigate();

    useEffect(() => {
        if (isStep1Complete) {
            navigate("/onboarding/step-2", { replace: true });
        }

        if (isLoading) {
            setIsLoading(true);
        }
    }, [isStep1Complete, navigate, isLoading, setIsLoading]);

    return (
        <div className="mx-auto flex min-h-[calc(100vh-200px)] max-w-[calc(100vw-35rem)] flex-col justify-center text-gray-700">
            <h3 className="text-center text-2xl font-semibold">Setup Your Store</h3>
            <p className="mt-2 text-center font-medium">Share your website URL so we can set up your store.</p>
            <div className="mb-10 mt-6">
                <div className="flex items-center justify-between">
                    <div className="relative z-20 flex items-center justify-center gap-2 rounded-full border border-blue-500 bg-white p-2 text-blue-700">
                        <CircleCheck />
                        <p>Step 1</p>
                    </div>
                    <div className="absolute w-[calc(50%-17.5rem)] min-w-11 border border-gray-300"></div>
                    <div className="relative z-20 flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white p-2 text-gray-500">
                        <CircleCheck />
                        <p>Step 2</p>
                    </div>
                    <div className="absolute left-[49%] w-[calc(50%-17.5rem)] min-w-11 border border-gray-300"></div>
                    <div className="relative z-20 flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white p-2 text-gray-500">
                        <CircleCheck />
                        <p>Step 3</p>
                    </div>
                </div>
            </div>
            <Card className="border p-4">
                <StoreInfoForm />
            </Card>
        </div>
    );
};

export default StepOne;
